module.exports = __webpack_public_path__ + "static/eastwood-message-sent-3ec4c717fee55a89e3971c7f859f37dd.svg";